import React from "react";

import styles from "./Overlay.css";

const Overlay = props => {
  return <div onClick={props.onClick} className={styles.overlay} />;
};

export default Overlay;
